import { PacketValueSerialType } from "../../../enum/PacketValueSerialType";
import Gun from "../../Gun";
import Player from "../../Player";

export default class EMPDart extends Gun {
    constructor(player: Player) {
        super(player, {
            damage: 5,
            fireRate: 1,
            reloadTime: 4,
            bulletSpeed: 400,
            magSize: 1,
            mouseTrigger: 2
        });
    }

    onShoot(): void {
        const pos = this.player.transform.position.add(this.player.transform.forward.scale(this.player.size + 4));
        const vel = this.player.velocity.add(this.player.transform.forward.scale(this.bulletSpeed));

        this.player.engine.createBulletForAll(pos, vel, [
            {
                key: "team",
                value: this.player.team,
                type: PacketValueSerialType.String
            },
            {
                key: "damage",
                value: this.player.chargedShot ? this.damage * 2 : this.damage,
                type: PacketValueSerialType.UInt
            },
            {
                key: "ownerName",
                value: this.player.name,
                type: PacketValueSerialType.String
            },
            {
                key: "isEMP",
                value: true,
                type: PacketValueSerialType.Bool
            }
        ]);
    }
}